// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TransparentDialog_modalOverlay__6l7vD","modalContent":"TransparentDialog_modalContent__3497D","closeButton":"TransparentDialog_closeButton__vhkgM"};